<template>
    <div id="app" class="iview-overlay" v-bind:class="showLoginPop?'lightBlur':''">
        <!--    <router-view/>-->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />

        <BackTop :height="200" :bottom="320" :right="20" class="back-top" v-if="pcBackTop">
            <ul>
                <li @click.stop="">
                    <span class="iconfont icon-weixin"></span>
                    <div class="qr-code qr-code1">
                        <img :src="siteInfo.qrcode" alt />
                        <p>扫一扫添加客服微信</p>
                    </div>
                </li>
                <li @click.stop="">
                    <span class="iconfont icon-qr-code"></span>
                    <div class="qr-code qr-code2">
                        <img :src="siteInfo.publicQrcode" alt />
                        <p>扫一扫关注官方微信</p>
                    </div>
                </li>
                <li>
                    <span class="iconfont icon-back-top"></span>
                </li>
            </ul>
        </BackTop>

        <!--弹出登录-->
        <!-- <div v-dom-portal="true" v-if="showLoginPop" class="LoginPop displayflex">
          <div class="sectorWrapper">
            <div class="graphPlate displayflex">
              <div class="title">
                请重新登录
              </div>
              <span>用户名</span>
              <input type="text" />
              <span>密码</span>
              <input type="password" />
              <div style="line-height: 32px;display: flex;align-items: center; padding-left: 20px;">
                <input type="checkbox" style="margin-right: 10px;" /> <label>保持登录状态</label>
              </div>
              <a class="popButton">登 录</a>
            </div>
          </div>
    </div>-->

        <component :is="comName" />
    </div>
</template>

<script>
import toLogin from "./components/login/toLogin";
import toRegister from "./components/login/toRegister";
import forgetPwd from "./components/login/forgetPwd";
import bus from "@/util/bus";

export default {
  name: "App",
  components: {
    toLogin,
    toRegister,
    forgetPwd
  },

  data() {
    return {
      comName: ""
    };
  },

  watch: {
    $route: {
      handler(to, from) {
        // console.log(to,from)
      },
      immediate: false,
      deep: true
    }
  },

  computed: {
    siteInfo() {
      let siteInfo = this.$store.getters["sessions/getSiteInfo"]
      if (siteInfo) {
        return siteInfo
      }
      return {
        copyrightChn: "",
        copyrightEng: "",
        contactPhone: "",
        contactAddress: "",
        location: "",
        contactEmail: "",
        wxNo: "",
        icpInfo: "",
        qrcode: "",
        publicQrcode: "",
        friendLink: [
          {
            friendLinkName: "",
            friendLinkUrl: ""
          }
        ],
        userAgreement: "",
        paymentAgreement: "",
        hbOfficeSummary: ""
      }
    },
    showLoginPop() {
      // let val = this.$store.getters["sessions/getSHowLoginPop"];
      // if(val) {
      //   // this.$nextTick(() => {
      //   //   document.querySelector('.basePlate').style.height = '480px';
      //   //   document.querySelector('.basePlate').style.width = '360px';
      //   // });
      //   document.querySelector('html').classList.add('fixedContainer');
      //   document.querySelector('body').classList.add('fixedContainer');
      // } else {
      //   document.querySelector('html').classList.remove('fixedContainer');
      //   document.querySelector('body').classList.remove('fixedContainer');
      // }
      // return val;
      return false;
    },
    pcBackTop() {
      return this.$store.getters["sessions/getShowBackTop"];
    }
  },
  mounted() {
    bus.$on("showLogin", res => {
      switch (res) {
        case 1: {
          this.comName = toLogin;
          break;
        }
        case 2: {
          this.comName = toRegister;
          break;
        }
        case 3: {
          this.comName = forgetPwd;
          break;
        }
        case 4: {
          this.comName = "";
          break;
        }
      }
    });
  },
};
</script>

<style lang="less">
@import url("assets/style/main.less");

#app {
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: #f2f2f2;
    overflow-x: hidden;
}

.back-top {
    ul {
        li {
            width: 50px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            border: 1px solid #ececec;
            background: #fff;
            cursor: pointer;
            margin-top: -1px;
            position: relative;

            &:last-child {
                margin-top: 5px;
            }

            .iconfont {
                font-size: 20px;
                color: #909090;
            }

            &:hover {
                .iconfont {
                    color: #fc6620;
                }
            }

            .qr-code {
                width: 170px;
                height: 200px;
                padding: 10px;
                border: 1px solid #ececec;
                border-radius: 10px;
                background: #fff;
                position: absolute;
                right: 70px;
                display: none;

                img {
                    display: block;
                    width: 100%;
                    height: 148px;
                    border: 1px dashed #ececec;
                }

                p {
                    height: 30px;
                    line-height: 30px;
                    font-size: 14px;
                    color: #333;
                    text-align: center;
                }
            }
            .qr-code1 {
                top: -45px;
            }
            .qr-code2 {
                top: -94px;
            }

            &:nth-child(1):hover {
                .qr-code1 {
                    display: block;
                }
            }
            &:nth-child(2):hover {
                .qr-code2 {
                    display: block;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue